<dashboard-header/>

<main class="flex-1" role="main">
  <div class="em-shell">
    <router-outlet/>
  </div>
</main>

<footer class="em-shell text-right text-slate-400 text-sm">
  Powered by Emsys Design LLC &copy; {{currentYear}}
</footer>

<vm-teleport name="dropdown"/>
